<template>
    <div class="progress">
        <div class="progress-bar" v-class="progressBarClasses" :style="progressBarStyles">
            <template v-if="showProgress">
                <slot name="label" :value="computedValue">
                    {{computedValue}}%
                </slot>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'oc-progress',
    props: {
        value: {
            type: [Number, String],
            default: 0
        },
        max: {
            type: [Number, String],
            default: 100
        },
        striped: {
            type: Boolean,
            default: false
        },
        stripedAnimation: {
            type: Boolean,
            default: false
        },
        variant: {
            type: String,
            default: 'success',
            validator: function (value) {
                return ['success', 'danger', 'warning', 'info', 'primary', 'secondary', 'dark'].indexOf(value) !== -1
            }
        },
        showProgress: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        }
    },
    methods: {
        // Converts a value (string, number, etc) to a number
        toFloat(value, defaultValue = NaN) {
            const float = parseFloat(value)
            return isNaN(float) ? defaultValue : float
        }
    },
    computed: {
        computedValue() {
            return this.toFloat(this.value, 0)
        },
        computedMax() {
            // Default to `100` for invalid values (`-x`, `0`, `NaN`)
            const max = this.toFloat(this.max, 0)
            return max > 0 ? max : 100
        },
        progressBarStyles() {
            return {
                width: 100 * (this.computedValue / this.computedMax) + '%'
            }
        },
        progressBarClasses() {
            let classes = {
                'progress-bar-striped': this.striped,
                'progress-bar-animated': this.stripedAnimation,
            }

            if( this.variant ) {
                classes[`bg-${this.variant}`] = true
            }

            return classes
        }
    }
}
</script>

<style scoped>
.progress-bar {
    transition: all 200ms ease 0s;
}
</style>
